import { Button } from "@mui/material";
import { useConnect } from "@stacks/connect-react";
import { authenticatedUserAddress, network } from "../../services/auth";
import { clientNetwork } from "../../lib/constants";
import { listCV, uintCV } from "@stacks/transactions";
import { getDeruptCoreContractPrivately } from "../../services/chime";
import { useEffect, useState } from "react";

const ClaimMiningRewardListButton = ({ claimList, longClaimList, setLongClaimList }) => {
    const [added, setAdded] = useState(false);
    const { doContractCall } = useConnect();

    function addClaimListToLongList() {
        const addList = claimList.filter(item => !longClaimList.includes(item));
        setLongClaimList(prev => [...prev, ...addList]);
        setAdded(true);
    };

    function removeClaimListToLongList() {
        const removeList = longClaimList.filter(item => !claimList.includes(item));
        setLongClaimList(removeList);
        setAdded(false);
    }

    const doClaimListReward = async () => {
        const userAddress = authenticatedUserAddress({ network: clientNetwork });
        const coreAddress = await getDeruptCoreContractPrivately();
        if (!coreAddress) return;

        doContractCall({
            contractAddress: coreAddress.split('.')[0],
            contractName: coreAddress.split('.')[1],
            functionName: 'claim-mining-reward-list',
            functionArgs: [listCV(claimList.map(blocks => uintCV(blocks)))],
            network: network({ network: clientNetwork }),
            stxAddress: userAddress
        });
    };

    useEffect(() => {
        const existing = longClaimList.filter(item => claimList.includes(item));
        setAdded(existing.length > 0 && (existing.length === claimList.length));
    }, [claimList, longClaimList])

    useEffect(() => {
        const existing = longClaimList.filter(item => claimList.includes(item));
        setAdded(existing.length > 0 && (existing.length === claimList.length));
    }, [])

    return (
        claimList.length > 0 && (
            <div className="claim-buttons">
                <Button size="small" variant="contained" sx={{ backgroundColor: '#f7931a' }} onClick={doClaimListReward}>Claim These</Button>
                <Button size="small" sx={{ color: 'white', borderColor: '#6444fe' }} variant="outlined" onClick={added ? removeClaimListToLongList : addClaimListToLongList}>{added ? "Remove These" : "Add These"}</Button>
            </div>
        )
    );
};

export default ClaimMiningRewardListButton;